import { render } from "./ValidationFeedback.vue?vue&type=template&id=ab6e294c"
import script from "./ValidationFeedback.vue?vue&type=script&lang=js"
export * from "./ValidationFeedback.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__